//const BASE_URL = 'https://crafttatva.appcheap.dev';
const BASE_URL = 'https://api.crafttatva.com';


async function request(url: string, method = 'GET', body: Record<string, any> | null = {}, headers: Record<string, string> = {}) {
    try {
        headers['Content-Type'] = 'application/json';

        const bodyContent = JSON.stringify(body);

        const response = await fetch(BASE_URL + url, { method, body: bodyContent, headers });
        const data = await response.json();
        if (!response.ok) {
            throw new Error(data?.message || 'Request failed');
        }
        return data;
    } catch (err) {
        throw err;
    }
}

export default request;